module.exports = __webpack_public_path__ + "static/media/tree_12.761a5d09.jpg";